import { useEffect, useRef } from 'react'
import { useDocumentStorage } from './useDocumentStorage'
import { useFFEStore } from '../store/ffeStore'
import _ from 'lodash'
import { FFEDocument } from '../types/ffe'
const AUTOSAVE_DELAY = 2000 // 2 seconds

export const useAutoSave = (loadedDocument: FFEDocument | null) => {
  const document = useFFEStore((state) => state.document)
  const setSaving = useFFEStore((state) => state.setSaving)
  const { saveDocument } = useDocumentStorage()
  const timeoutRef = useRef<number>()
  const hasSaved = useRef(false)

  useEffect(() => {
    // if equal to loadedDocument, return
    const omittedKeys = ['_id', 'id', 'createdAt', 'updatedAt']
    const condition = !loadedDocument || _.isEqual(_.omit(document, omittedKeys), _.omit(loadedDocument, omittedKeys))
    if (condition && !hasSaved.current) {
      console.log('Skipping autosave - no document changes')
      return
    }

    if (!document._id) return
    // Clear existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    setSaving(true)

    // Set new timeout
    timeoutRef.current = setTimeout(async () => {
      console.log('Autosaving document...')
      await saveDocument()
      hasSaved.current = true
      setSaving(false)
    }, AUTOSAVE_DELAY)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [document])
}
